export const HERO_DEMO_SCENARIOS = [
  {
    id: 'fps-26a-payroll',
    chipLabel: '26A Payroll updates',
    release: '26A',
    question: 'What changed with FPS employee address reporting in 26A Payroll?',
    retrieval: [
      {
        file: 'FPS Enhancement: Control Employee Address Reporting',
        score: 69,
        verified: false,
        preview: 'You can control whether employee addresses are reported for all employees or only new starters on the Full Payment Submission, using the new Employee Address on FPS from Tax Year 2024-25 field.',
      },
    ],
    answer: [
      "Starting in 26A, Oracle introduced a new field called Employee Address on FPS from Tax Year 2024-25 on the Statutory Deductions calculation card. This gives you control over whether employee addresses are reported for all employees or only new starters on the Full Payment Submission (FPS) to HMRC.",
      "The change supports data minimization principles while maintaining compliance. The default setting is 'All Employees,' which maintains the previous behavior, but you can now restrict it to new starters only if that's more appropriate for your organization's data privacy approach.",
      "You configure this at the organization level — specifically on the Statutory Deductions calculation card for your Payment Statutory Unit (PSU) or Tax Reporting Unit (TRU). The setting is found in the Pay As You Earn Default calculation card component. This applies to FPS for both the tax year ending April 2025 and the tax year ending 2026.",
    ],
    sourceRef: 'https://docs.oracle.com/en/cloud/saas/readiness/hcm/26a/payr-26a/26A-payroll-wn-f41802.htm',
  },
  {
    id: 'iso20022-26a-payroll',
    chipLabel: 'ISO 20022 payments',
    release: '26A',
    question: 'What are the tips for setting up ISO 20022 payments in Payroll 26A?',
    retrieval: [
      {
        file: 'Payments based on ISO 20022 standard',
        score: 65,
        verified: false,
        preview: 'Confirm your bank supports the 2019 version of the pain.001.001.09 schema, verify Initiating Party ID and Debtor Agent BIC are correctly configured, and validate all employee bank accounts have properly formatted IBAN or SWIFT/BIC codes.',
      },
    ],
    answer: [
      "Before you flip the switch on ISO 20022 payments in release 26A, make sure your bank actually supports the 2019 version of the pain.001.001.09 schema — this isn't optional. If they're on an older version, the file will bounce back or fail validation silently. Confirm this with your treasury or banking partner first.",
      "On the Oracle side, double-check your Payment Process Profile. The Initiating Party ID and Debtor Agent (BIC) need to be populated correctly — ISO 20022 is strict about party identification, and missing or malformed values will cause transmission failures.",
      "Employee bank account data is where most issues surface. Every account needs to have either a valid IBAN or a properly formatted SWIFT/BIC code. ISO 20022 is hypersensitive to formatting errors — even an extra space or missing digit will cause the payment to reject. Run a data quality check on your bank account records before your first production run.",
      "If you've customized the EFT Report template in the past, you'll need to refresh it: save your custom template locally, delete the custom version from Shared Folders, then re-customize the delivered version and upload your saved template back. This ensures you're working with the latest 26A schema updates.",
    ],
    sourceRef: 'https://docs.oracle.com/en/cloud/saas/readiness/hcm/26a/payr-26a/26A-payroll-wn-f43839.htm',
  },
];

/** Strip hero-only fields for AnimatedChatDemo detailed mode */
export function toDetailedDemoShape(scenario) {
  return {
    question: scenario.question,
    retrieval: scenario.retrieval.map(({ file, score, verified }) => ({ file, score, verified })),
    answer: scenario.answer,
  };
}

export const DETAILED_DEMOS = HERO_DEMO_SCENARIOS.map(toDetailedDemoShape);
